import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { updateUrl: { type: Boolean, default: false } }
  static targets = ["tab", "content"]

  connect() {
    this.contentTargets.forEach((frame) => {
      frame.addEventListener("turbo:frame-render", this.updateUrlForActiveTab)
    })

    document.addEventListener("ui:tab:select", this.handleSelectEvent)
  }

  disconnect() {
    this.contentTargets.forEach((frame) => {
      frame.removeEventListener("turbo:frame-render", this.updateUrlForActiveTab)
    })

    document.removeEventListener("ui:tab:select", this.handleSelectEvent)
  }

  handleSelectEvent = (event) => {
    const tabRef = event.detail.ref
    const tabToSelect = this.tabTargets.find((tab) => tab.dataset.ref == tabRef)

    if (tabToSelect) {
      this.select({ currentTarget: tabToSelect }, event.detail.refresh)
    }
  }

  select(event, refresh = false) {
    const currentlySelectedTab = this.tabTargets.find((tab) => tab.dataset.selected === "true")
    const newlySelectedTab = event.currentTarget
    const newlySelectedContent = this.contentTargets.find((frame) => frame.dataset.ref == newlySelectedTab.dataset.ref)

    if (currentlySelectedTab === newlySelectedTab && !refresh) {
      return
    }

    this.tabTargets.forEach((tab) => {
      tab.dataset.selected = false
      tab.setAttribute("aria-selected", "false")
      tab.setAttribute("tabindex", "-1")
    })

    newlySelectedTab.dataset.selected = true
    newlySelectedTab.setAttribute("aria-selected", "true")
    newlySelectedTab.setAttribute("tabindex", "0")

    this.contentTargets.forEach((frame) => {
      frame.dataset.selected = false
    })

    newlySelectedContent.dataset.selected = true

    if (refresh) {
      if (newlySelectedContent.getAttribute("complete") === null) return

      const src = newlySelectedContent.src

      newlySelectedContent.src = src
    }
  }

  updateUrlForActiveTab = () => {
    if (!this.updateUrlValue) {
      return
    }

    const tab = this.tabTargets.find((tab) => tab.dataset.selected === "true")
    const ref = tab.dataset.ref
    const url = new URL(window.location)

    this.selectedUrl = url.searchParams.set("selected_tab", ref)

    window.history.replaceState({}, "", url)

    // Forces Turbo to recognize the URL change so we can morph
    window.Turbo.session.view.lastRenderedLocation = url
  }
}
